export default class ShareCapture {
  constructor() {
    this.toast = $('#_captureShareContainer');
    this.buttion = '#_captureShare';
    this.fixShareWrapper = '_fixed_share';
    this.timer = 0;
    this.setEvent();
  }

  onScroll(top) {
    const headerHeight = TMON.oApp.oUtil.getHeaderHeight();
    const defaultSpace = 12;
    if (top === 0) {
      this.setTopPosition(headerHeight);
      return;
    }

    const curFiexdItem = $('.fixed._fixed:last');
    this.setTopPosition(headerHeight + curFiexdItem.height() + defaultSpace);
  }

  setEvent() {
    $('body').on('click', this.buttion, e => {
      this.open(e);
    });
  }

  clearEvent() {
    $('body').off('click', this.buttion);
  }

  open() {
    TMON.oApp.oUtil.handleOpenLayer({
      welTargetLayer: $(`#${this.fixShareWrapper}`),
    });
  }

  showToast() {
    clearTimeout(this.timer);
    this.toast.show();
    this.timer = setTimeout(() => {
      clearTimeout(this.timer);
      this.toast.fadeOut();
    }, 5000);
  }

  setTopPosition(val) {
    this.toast.css({ top: `${val}px` });
  }
}
